<template>
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-12">
            <BaseComponent v-for="(component, index) in left_components" :key="index" :componentData="component"/>
        </div>
        <div class="col-md-6 col-12 bottom">
            <BaseComponent v-for="(component, index) in right_components" :key="index" :componentData="component"/>
        </div>
      </div>
    </div>
</template>

<script>
import BaseComponent from '../components/BaseComponent'
export default {
  name: "Cols-50-50",
  props: ["left_components", "right_components", "acf_fc_layout"],
  components:{ BaseComponent}
};
</script>

<style lang="scss" scoped>
  @include media-breakpoint-down(sm){
    .bottom{
      margin-top: 20px;
    }
  }
</style>
